import React from 'react';
import { Redirect } from 'react-router';

const IframeRoute = props => {
       const closeIframe = () => {
        console.log("CLOSING IFRAME MESSAGE SENT");
        window.parent.postMessage("message", '*');
      };

    const doRender = () => {
        var targetPage = sessionStorage.getItem("targetPage");
        console.log("IframeRoute render redirectPath:: ", targetPage);
        if(targetPage) {
            closeIframe();
            return <Redirect to= {targetPage} />
        } else {
            return null;
        }
    }

    return doRender();
}

export default (IframeRoute);